import { Dispatch } from 'react';
import { TServiceClientActionTypes } from '../types';
import { SET_LOADING } from 'src/contexts/types';
import { handleError } from 'src/contexts/utils/handleError';
import { GET_SERVICE_CLIENT } from '../constants/actions';
import { HEADERS } from 'src/constants/headers';
import { ApiV2 } from 'src/api/apiv2';
import { TFunction } from 'i18next';
import { VariantType } from 'notistack';
import { TCurrentTemplate } from 'src/modules/conversations/components/modalTemplates/types';

export type TSendTemplateServiceClientDeps = {
    t: TFunction;
    customAlert: (
        message: string,
        variant?: VariantType,
        options?: Record<string, unknown>,
        actionUrl?: string,
        playSound?: boolean
    ) => void;
};

export type TSendTemplateServiceClientOptions = {
    playSound?: boolean;
};

export const sendTemplateServiceClient = async (
    dispatch: Dispatch<TServiceClientActionTypes>,
    template: TCurrentTemplate,
    serviceClientId: string,
    deps: TSendTemplateServiceClientDeps,
    options?: TSendTemplateServiceClientOptions
) => {
    const { t, customAlert } = deps;
    const playSound = options?.playSound !== false;

    dispatch({ type: SET_LOADING });
    try {
        const res = await ApiV2.post(
            `/service-clients/${serviceClientId}/sendTemplate`,
            { ...template, serviceClient: serviceClientId },
            HEADERS()
        );

        dispatch({
            type: GET_SERVICE_CLIENT,
            payload: res.data.data,
        });

        customAlert(
            t('TwilioTemplates.Send'),
            'success',
            {},
            undefined,
            playSound
        );
    } catch (error) {
        if (error instanceof Error) dispatch(handleError(error));
    }
};